/**
 * Valid suggestion types for build mode suggestions
 */
export enum BuildModeSuggestionType {
  SETUP_ZAPS = "🚀 Setup My Zaps",
  CREATE_AUTH = "🔌 Create new App Connection",
  LEAD_GENERATION = "🛠️ Lead Generation System",
  CUSTOMER_SUPPORT = "🎧 Customer Support Automation",
  ECOMMERCE_ORDER = "🛒 E-commerce Order Processing",
  TOUR_MY_CANVAS = "🎯 Tour My Canvas",
  EXPLAIN_MY_CANVAS = "📋 Explain My Canvas",
}
